import { createContext, useContext, type ReactNode } from 'react';
import type { FundraisersModuleConfig } from './fundraisers-config';

const FundraisersContext = createContext<FundraisersModuleConfig | null>(null);

export function FundraisersModuleProvider({
  config,
  children,
}: {
  config: FundraisersModuleConfig;
  children: ReactNode;
}) {
  return <FundraisersContext.Provider value={config}>{children}</FundraisersContext.Provider>;
}

export function useFundraisersModule(): FundraisersModuleConfig {
  const config = useContext(FundraisersContext);
  if (config === null) throw new Error('FundraisersModuleProvider is missing');
  return config;
}
